import { Expose, Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import {
  PointConfigurationApplicationModeEnum,
  PointConfigurationFunctionalityEnum,
  PointConfigurationPaymentMethodEnum,
} from "@altertec_gparn/lib";
import { OperativeUnitDto } from "@/core/features/operative-units/operative-unit.dto";
import { toEuros } from "@/utils/numberUtils";

export class PointConfigurationDto extends BaseEntityDto {
  @Expose()
  operativeUnitId?: string | null;

  @Expose()
  @Type(() => OperativeUnitDto)
  operativeUnit?: OperativeUnitDto | null;

  @Expose()
  functionality: PointConfigurationFunctionalityEnum;

  @Expose()
  paymentMethod: PointConfigurationPaymentMethodEnum;

  @Expose()
  appliesToProjectOperativeUnit: boolean;

  @Expose()
  isTravelTimePaidAsOrdinary: boolean;

  @Expose()
  @Transform(({ value }) => toEuros(value, false))
  fixedPriceFirstPoint?: number | null;

  @Expose()
  @Transform(({ value }) => toEuros(value, false))
  fixedPriceSecondPoint?: number | null;

  @Expose()
  applicationMode: PointConfigurationApplicationModeEnum;

  @Expose()
  payrollConceptKey?: string | null;
}
